import { render, staticRenderFns } from "./DateMenu.vue?vue&type=template&id=c80df66e"
import script from "./DateMenu.vue?vue&type=script&lang=js"
export * from "./DateMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports